/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Unreleased

1 = Released

2 = Recalled


 */
export type BidPackageReleasedStatus =
  (typeof BidPackageReleasedStatus)[keyof typeof BidPackageReleasedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BidPackageReleasedStatus = {
  Unreleased: 0,
  Released: 1,
  Recalled: 2,
} as const;
